import { jsx } from 'react/jsx-runtime';
import { clsx } from 'clsx';
import styles from './Stack.module.css.js';

function Stack({ direction = "column", justifyContent = "start", alignItems = "stretch", spacing = "base", wrap = "nowrap", children, }) {
    // Responsive props
    const normalizedDirection = normalizeResponsiveProp(direction);
    const directionClass = clsx({
        [styles.directionColumn_desktop]: normalizedDirection.desktop === "column",
        [styles.directionColumn_mobile]: normalizedDirection.mobile === "column",
    });
    // Non-responsive props (to be converted as needed)
    const justifyClass = clsx({
        [styles.justifyStart]: justifyContent === "start",
        [styles.justifyCenter]: justifyContent === "center",
        [styles.justifyEnd]: justifyContent === "end",
        [styles.justifyStretch]: justifyContent === "stretch",
        [styles.justifySpaceBetween]: justifyContent === "space-between",
    });
    const alignClass = clsx({
        [styles.alignStart]: alignItems === "start",
        [styles.alignCenter]: alignItems === "center",
        [styles.alignEnd]: alignItems === "end",
        [styles.alignStretch]: alignItems === "stretch",
    });
    const wrapClass = clsx({
        [styles.wrap]: wrap === "wrap",
        [styles.noWrap]: wrap === "nowrap",
    });
    return (jsx("div", { className: clsx(styles.Stack, styles[spacing], directionClass, justifyClass, alignClass, wrapClass), children: children }));
}
function normalizeResponsiveProp(prop) {
    if (typeof prop === "object") {
        return prop;
    }
    return { mobile: prop, desktop: prop };
}

export { Stack, normalizeResponsiveProp };
//# sourceMappingURL=Stack.js.map
